module.exports = __webpack_public_path__ + "static/media/flexible.4d152ee7.png";